import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'relative inline-flex shrink-0 items-center justify-center gap-2 rounded-md text-sm font-semibold whitespace-nowrap outline-none transition-[color,background-color,border-color,box-shadow,transform] duration-150 active:scale-[0.98] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:transform-none disabled:opacity-60 disabled:shadow-none motion-reduce:transition-none motion-reduce:hover:translate-none motion-reduce:active:scale-none [&_svg]:pointer-events-none [&_svg]:size-4',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-primary-foreground shadow-sm hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-md active:bg-primary/80',
        secondary:
          'bg-secondary text-secondary-foreground hover:-translate-y-0.5 hover:bg-secondary/80 hover:shadow-sm active:bg-secondary/70',
        outline:
          'border border-border bg-background shadow-xs hover:-translate-y-0.5 hover:bg-accent hover:text-accent-foreground hover:shadow-sm active:bg-accent/80',
        ghost:
          'hover:bg-accent hover:text-accent-foreground active:bg-accent/80',
        destructive:
          'bg-destructive text-white shadow-sm hover:-translate-y-0.5 hover:bg-destructive/90 hover:shadow-md active:bg-destructive/80',
        link: 'text-primary underline-offset-4 hover:underline active:opacity-70',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 gap-1.5 px-3 text-xs',
        lg: 'h-11 px-6 text-base',
        icon: 'size-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
